export const GB_FEATURES = {
  EXP_ALT_FOLLOW_BREEDER_CTA: 'exp_alt_follow_breeder_cta',
  EXP_STORIES_LABEL: 'exp_stories_label'
};
